var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-title text-center px-md-2 mb-3"},[_c('h2',{staticClass:"m-0",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.subtitle)}})])}
var staticRenderFns = []

export { render, staticRenderFns }